import { FacilityDetail } from "./FacilityDetail";
import { BusinessPotential } from "./BusinessPotential";
import { EstimatesAndActuals } from "./EstimatesAndActuals";
import { Equipment } from "src/app/equipments/services/equipment.service";

export class Facility
{
  siteId: number;
  activeFlag: boolean;
  productionFacilityId: number;
  siteName: string;
  siteDescription: string;
  localCompanyName: string;
  stateProvince: string;
  country: string;
  insertedDate: Date;
  facilityType: string;
  facilityStatus: string;
  facilityDetail: FacilityDetail;
  actualsEdited: boolean;
  equipmentUpdated: boolean;
  businessPotential: BusinessPotential;
  equipments: Equipment[];
  estimatesAndActuals: EstimatesAndActuals[];
  estimatesAndActualsTemp: EstimatesAndActuals[];
}
